import * as React from 'react';
import style from './top-badge.scss';
import { Badge, Box, Tooltip } from '@wix/design-system';
import { composer } from '../../../../component-decorators/composer';
import { useSolution } from '../contexts/solution';
import { getAppBadgeTheme, getAppBadgeTitle, getAppBadgeTooltipContent, } from '../../../common';
export const TopBadge = composer()
    .withExperiments()
    .withTranslation()
    .compose((props) => {
    const solution = useSolution();
    const { isBundleAppInstalled, isBundleAppNotInstalled, name, isVoucherApp, } = solution;
    const { t, experiments } = props;
    const badgeTitle = getAppBadgeTitle(isBundleAppInstalled, isBundleAppNotInstalled, undefined, experiments, undefined, solution?.id);
    const badgeTheme = getAppBadgeTheme(badgeTitle);
    const showHotelsToolTip = badgeTitle === 'solutionBox.badge.beta';
    const showTooltip = isBundleAppInstalled || isBundleAppNotInstalled || showHotelsToolTip;
    const tooltipContent = getAppBadgeTooltipContent(isBundleAppInstalled, isBundleAppNotInstalled, isVoucherApp, showHotelsToolTip);
    return (React.createElement(Box, { dataHook: "solution-top-section", className: style.topSection }, showTooltip && tooltipContent ? (React.createElement(Box, { marginTop: "-2px" },
        React.createElement(Tooltip, { placement: "top", content: t(tooltipContent, {
                appName: name,
            }) },
            React.createElement(TopBadgeBase, { badgeTitle: t(badgeTitle), badgeTheme: badgeTheme })))) : (React.createElement(TopBadgeBase, { badgeTitle: t(badgeTitle), badgeTheme: badgeTheme }))));
});
export const TopBadgeBase = ({ badgeTitle, badgeTheme }) => (React.createElement(React.Fragment, null, badgeTitle && (React.createElement(Badge, { dataHook: "solution-badge", ...badgeTheme }, badgeTitle))));
//# sourceMappingURL=TopBadge.js.map